import SerialClient from '../serialClient';

export function createSerialAdapter({ ClientCtor = () => new SerialClient() } = {}) {
  let client = null;
  return {
    async connect(port) {
      if (client) { await client.forceClose().catch(() => {}); }
      client = ClientCtor();
      await client.connect(port);
    },
    async getDeviceState() {
      const info = await client.info();
      return { firmware: info.firmware, protocolVersion: client.protocolVersion() };
    },
    async flashOta(bin, onProgress) {
      await client.flashFirmware(bin, (phase, recv, total) => {
        if (onProgress) onProgress(total ? recv / total : 0);
      });
    },
    async readVersion() {
      const info = await client.info();
      return info.firmware;
    },
    async release() {
      if (client) await client.forceClose().catch(() => {});
    },
    raw() {
      return client;
    },
  };
}
